import React from 'react';
import styles from '@web-common/components/UI/SiriusContact/tree/index.module.scss';
import Tree from '@web-mail/common/components/VListTree/VListTree';
import { transTreeName } from './data';
export const rootBaseKey = 'TreeBaseRootKey';
export const selectBtnNameMap = {
    enterprise: transTreeName('orgBtn'),
    team: transTreeName('teamBtn'),
    personal: transTreeName('personalOrgBtn'),
    clue: transTreeName('select'),
    customer: transTreeName('select'),
};
const BaseTree = props => {
    const { treeWidth, treeHeight, treeInitData, expandedKeys, renderTitle, renderNode, loadData, onLoadMoreNode, cardGroupDecorate, onSelect, onExpand, hasMore = false, } = props;
    return (React.createElement("div", { className: styles.ContactTree },
        React.createElement(Tree, { onExpand: onExpand, selectedKeys: [], hasMore: hasMore, width: treeWidth, height: treeHeight, onLoadMoreNode: async (page, parentNode) => {
                if (onLoadMoreNode) {
                    await onLoadMoreNode(parentNode);
                }
                return true;
            }, loadData: async (data) => {
                if (loadData) {
                    await loadData(data);
                }
                return true;
            }, defaultExpandedKeys: [...(expandedKeys || [])], expandedKeys: [...(expandedKeys || [])], onSelect: (_, { node }) => {
                onSelect && onSelect(node);
            }, treeData: treeInitData, titleRender: data => {
                const nodeData = data;
                if (nodeData.isLeaf) {
                    return renderTitle ? renderTitle(nodeData) : undefined;
                }
                else {
                    return renderNode ? renderNode(nodeData) : undefined;
                }
            }, icon: null, cardGroupDecorate: cardGroupDecorate })));
};
export default BaseTree;
